/**
 * Image cache for the canvas. The draw loop asks for an image every frame and
 * gets undefined until it has loaded, then the real thing; nothing needs to
 * re-render or await.
 */
const cache = new Map<string, HTMLImageElement | null>();

export function image(url: string | undefined): HTMLImageElement | undefined {
  if (!url) return undefined;
  const cached = cache.get(url);
  if (cached !== undefined) return cached ?? undefined;

  cache.set(url, null); // mark as loading so one request is made
  const img = new Image();
  img.decoding = "async";
  img.onload = () => cache.set(url, img);
  img.onerror = () => cache.set(url, null); // give up quietly: the canvas falls back
  img.src = url;
  return undefined;
}

/** Preloads images so they are ready by the time playback starts. */
export function preload(urls: Array<string | undefined>): void {
  for (const url of urls) image(url);
}
